import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const getHeaders = useCallback((token) => ({
    Authorization: `Bearer ${token || localStorage.getItem("hl_token") || ""}`,
  }), []);

  // Check existing session on mount
  useEffect(() => {
    const token = localStorage.getItem("hl_token");
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => setUser({ ...res.data, token }))
        .catch(() => localStorage.removeItem("hl_token"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const adminLogin = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/admin-login`, { email, password });
    localStorage.setItem("hl_token", data.token);
    setUser({ ...data.user, token: data.token });
    return data;
  };

  const ownerLogin = async (phone, password) => {
    const { data } = await axios.post(`${API}/auth/owner/login`, { phone, password });
    localStorage.setItem("hl_token", data.token);
    setUser({ ...data.user, token: data.token });
    return data;
  };

  const logout = async () => {
    const token = localStorage.getItem("hl_token");
    try {
      await axios.post(`${API}/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch (_) {
      // Local logout still succeeds if the server session is already unavailable.
    }
    localStorage.removeItem("hl_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, adminLogin, ownerLogin, logout, getHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { API };
